import { type InAppNotificationType } from "@doitintl/cmp-models";

import { toSentenceCase } from "../../../utils/string";

const notificationsSettingsTexts = {
  table: {
    title: "My notifications",
    headers: {
      type: "Type",
      selectedNotifications: "Selected notifications",
    },
    row: {
      realTime: {
        aria: "Real time in-app notifications are enabled. This will display notifications as they happen while you are using the console.",
        tooltip: "This will display notifications as they happen while you are using the console.",
      },
      editNotification: "Edit notification",
      noneSet: "(None set)",
      notSet: "(Not set)",
      allTypes: "All types",
      inApp: "In-app",
    },
  },
  settings: {
    selection: {
      title: "Select in-app notifications",
      description: "Choose which in-app notifications you want to receive",
      options: (inAppNotificationType: InAppNotificationType): string => toSentenceCase(inAppNotificationType),
    },
    realTime: {
      title: "Real-time notifications",
      description: "This will display notifications as they happen while you are using the console.",
      toggleLabel: "Enable real-time notifications",
      preview: "Notification preview",
    },
    buttons: {
      cancel: "Cancel",
      save: "Save",
      back: "Back",
    },
    snackbars: {
      error: "Failed to save notification settings",
      success: "In app notifications settings saved",
    },
  },
};

export default notificationsSettingsTexts;
